<template>
  <div class="api-layer">
    <fieldset>
      <legend>Room</legend>

      <div class="api-box inline"
           :class="{inline: !roomInfo.desc}"
      >
        <label class="api-title">info</label>
        roomUrlId:<input type="text" name="roomUrlId" />
        roomId:<input type="text" name="roomId" />
        <button @click="getRoomInfo">OK</button>
        <div
            v-if="!!roomInfo.desc"
        >
          <pre>{{ roomInfo.desc }}</pre>
        </div>
      </div>

    </fieldset>
  </div>
</template>

import {SysAdmin} from "@/core/sysadmin/sysadmin.api";

<script>
import {SysAdmin} from "@/core/sysadmin/sysadmin.api";
import SysAdminBase from "@/components/Sysadmin/SysAdminBase";

export default {
  name: "Room",
  mixins: [SysAdminBase],
  data() {
    return {
      roomInfo: {
        desc: null
      },
    }
  },

  methods: {
    ...(() => {
      const methods = {
        async getRoomInfo(e) {
          const roomId = this.getRoomIdValue(e);
          const roomUrlId = this.getRoomUrlIdValue(e);
          if(!roomId && !roomUrlId) return;

          const data = await SysAdmin.get({url: '/room/info', params: {
              roomId, roomUrlId
          }})
          console.log(data);

          this.roomInfo.desc = data;
        },
      }

      return SysAdmin.createDebounceMethods(methods);
    })(),
  },
}
</script>

<style lang="scss" scoped>

</style>